import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import { ProjectService } from '../core/project.service';
import * as data from '../core/content.json';



@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {

  public showMenu = false;
  public galeria = {};


  constructor(
    private router: Router,
    private projectService: ProjectService,
    private activatedRoute: ActivatedRoute
    )
  {
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };
  }

  public lang = '';
  public content = {};
  public contentMenu = {};

  ngOnInit(): void {
    this.setLang();


    this.galeria = { galeria: [
      {url: "assets/home/IMG_6103.PNG"},
      {url: "assets/home/IMG_6105.PNG"},
      {url: "assets/home/IMG_5669.jpeg"},
    ]};
    this.loadProjects();
  }

  async loadProjects() {
    const projects = await this.projectService.getAll();
    console.log(projects);
  }

  redirect(rota){
    rota = (this.lang == 'en') ? rota + '?lang=en' : rota;
    this.router.navigateByUrl(rota);
  }

  setLang(){
    this.lang = (this.activatedRoute.snapshot.queryParams['lang'] == undefined) ? 'pt-br' : this.activatedRoute.snapshot.queryParams['lang'];

    if(this.lang == 'en'){
      this.content = data['en']['home'];
      this.contentMenu = data['en']['menu'];
    }else{
      this.content = data['pt-br']['home'];
      this.contentMenu = data['pt-br']['menu'];
    }
  }

  changeLang() {
    // Navigate to the same route with a different lang parameter
    this.lang = this.activatedRoute.snapshot.queryParams['lang'];

    const url = this.router.url.replace(/\?lang=(en|pt-br)/, '');

    if(this.lang == 'en'){
      this.router.navigate([url], { queryParams: { lang: 'pt-br' } });
    }else{
       this.router.navigate([url], { queryParams: { lang:'en' } });
    }
  }

}
